import styled from 'styled-components';

export const HeadingMedium = styled.div`
    display: flex;
    column-gap: 20px;
    align-items: center;
    font-size: 0.8rem;
    font-weight: 500;
    padding: 5px;
    padding-bottom: 0px;
    background-color: #f4f4f4;
`;

export const HeadingSmall = styled.div`
    min-height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.8rem;
    font-weight: 500;
    margin: 0 0 0.5rem;
    padding: 5px;
    background-color: #f4f4f4;
    border-bottom: 2px solid #00447e;
`;


export const ExpandSubHeading = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.9rem;
    text-transform: uppercase;
    color: #0aa5dc;
    font-weight: 500;
    letter-spacing: 0;
    padding: 0 0 0 10px;    
    width: 25rem;
`;


export const SubSectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.9rem;
    text-transform: uppercase;
    color: #0aa5dc;
    font-weight: 500;
    letter-spacing: 0;
    padding: 0 0 0 10px;    
`;


export const SectionContent = styled.div`
    padding: 5px;
    margin: 0 0 1rem;
    position: relative;
`;

export const SectionHeaderComponent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px;
    font-weight: bold;
    background: #e4e4e4;
    .close-button {
        margin-right: 0.5rem;
    }
`;